"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_bootstrap_1 = require("react-bootstrap");

var prop_types_1 = __importDefault(require("prop-types"));

var classnames_1 = __importDefault(require("classnames"));

var SzIcon_1 = __importDefault(require("../SzIcon/SzIcon"));

require("./SzAlert.scss");

function SzAlert(_a) {
  var children = _a.children,
      type = _a.type;
  var containerClasses = classnames_1.default('sz-alert d-flex align-items-stretch justify-content-between font-weight-bold my-3 w-100 pl-3 p-0 border-0', {
    'text-white bg-danger': type === 'danger',
    'text-primary text-uppercase bg-secondary': type === 'success',
    'text-secondary text-uppercase bg-primary': type === 'primary'
  });
  var iconProps = {
    variant: 'bold',
    icon: type === 'primary' || type === 'success' ? 'check' : 'alert-triangle'
  };
  var iconContainerClasses = classnames_1.default('sz-alert__icon d-flex align-items-center px-2', {
    'bg-secondary text-primary': type === 'primary'
  });
  return react_1.default.createElement(react_bootstrap_1.Alert, {
    className: containerClasses
  }, react_1.default.createElement("div", {
    className: "sz-alert__text d-flex align-items-center"
  }, children), react_1.default.createElement("div", {
    className: iconContainerClasses
  }, react_1.default.createElement(SzIcon_1.default, __assign({}, iconProps))));
}

exports.default = SzAlert;
SzAlert.propTypes = {
  type: prop_types_1.default.oneOf(['primary', 'success', 'danger']).isRequired,
  children: prop_types_1.default.node.isRequired
};
SzAlert.defaultProps = {
  type: 'primary'
};